import { render, staticRenderFns } from "./tocco-event-next-testing.vue?vue&type=template&id=59147722"
import script from "./tocco-event-next-testing.vue?vue&type=script&lang=ts"
export * from "./tocco-event-next-testing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports